import Layout from '@/layout/ezpay-index.vue'

export const developManageRouter = {
  path: '/developManage',
  component: Layout,
  redirect: '/developManage/detail',
  name: 'Develop_Manage',
  meta: { title: 'develop_manage', icon: 'developer' },
  children: [
    {
      path: 'application/list',
      name: 'Develop_Manage_App_List',
      component: () => import('@/views/ezpay/develop-manage/merchant-app-list'),
      meta: {
        title: 'application_manage_list', noCache: false,
        auth: ['AUTH_CODE_APPLICATION_CONFIGURATION']
      },
      hidden: true
    },
    {
      path: 'application/detail',
      name: 'Develop_Manage_App_Detail',
      component: () => import('@/views/ezpay/develop-manage/merchant-app-detail'),
      meta: {
        title: 'application_manage_detail', noCache: false,
        auth: ['AUTH_CODE_APPLICATION_CONFIGURATION']
      }
    }

  ]
}

if (process.env.NODE_ENV !== 'production') {
  const list = [{
    path: 'simulation/disbursement',
    name: 'Develop_Manage_simulation_disbursement',
    component: () => import('@/views/ezpay/develop-manage/system-simulation-disbursement'),
    meta: {
      title: 'simulation_payout', noCache: false,
      auth: ['AUTH_CODE_APPLICATION_CONFIGURATION']
    }
  },
    {
      path: 'simulation/payment',
      name: 'Develop_Manage_simulation_payment',
      component: () => import('@/views/ezpay/develop-manage/system-simulation-payment'),
      meta: {
        title: 'simulation_payment', noCache: false,
        auth: ['AUTH_CODE_APPLICATION_CONFIGURATION']
      }
    },
    {
      path: 'simulation/dynamic/payment',
      name: 'Develop_Manage_simulation_dynamic_payment',
      component: () => import('@/views/ezpay/develop-manage/system-simulation-dynamic-payment'),
      meta: {
        title: 'simulation_dynamic_payment', noCache: false,
        auth: ['AUTH_CODE_APPLICATION_CONFIGURATION']
      }
    },
    {
      path: 'simulation/checkout/payment',
      name: 'Develop_Manage_simulation_checkout_payment',
      component: () => import('@/views/ezpay/develop-manage/system-simulation-checkout-payment'),
      meta: {
        title: 'simulation_checkout_payment', noCache: false,
        auth: ['AUTH_CODE_APPLICATION_CONFIGURATION']
      }
    },
    {
      path: 'simulation/refund',
      name: 'Develop_Manage_simulation_refund',
      component: () => import('@/views/ezpay/develop-manage/system-simulation-refund'),
      meta: {
        title: 'simulation_refund', noCache: false,
        auth: ['AUTH_CODE_APPLICATION_CONFIGURATION']
      }
    }
    ]
  developManageRouter.children = developManageRouter.children.concat(list)
}
